"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const systemComponents_1 = require("@/store/ducks/systemComponents");
const selectors_1 = require("@/store/ducks/systemComponents/selectors");
const deleteSystemComponentsAssociationUseCase_1 = __importDefault(require("@/useCases/systemComponents/deleteSystemComponentsAssociationUseCase"));
const index_view_1 = __importDefault(require("./index.view"));
function RemoveSystemComponentAssociationDialog({ arrayHelpers }) {
    const { systemId } = (0, react_router_dom_1.useParams)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isDialogVisible = (0, react_redux_1.useSelector)(selectors_1.isDeleteAssociationDialogOpenSelector);
    const componentToBeUnlinked = (0, react_redux_1.useSelector)(selectors_1.componentToBeUnlinkedSelector);
    const rowIndexToBeDeleted = (0, react_redux_1.useSelector)(selectors_1.rowIndexToBeRemovedSelector);
    const isDeletingSystemComponent = (0, react_redux_1.useSelector)(selectors_1.isDeletingSystemComponentSelector);
    const onClose = react_1.default.useCallback(() => {
        dispatch((0, systemComponents_1.closeDeleteAssociationModal)());
    }, [systemComponents_1.closeDeleteAssociationModal]);
    const onProceed = react_1.default.useCallback(() => {
        arrayHelpers.remove(rowIndexToBeDeleted);
        (0, deleteSystemComponentsAssociationUseCase_1.default)(systemId, componentToBeUnlinked?.id)(dispatch);
    }, [arrayHelpers, rowIndexToBeDeleted, componentToBeUnlinked, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { isOpen: isDialogVisible, onClose: onClose, isDeletingSystemComponent: isDeletingSystemComponent, onDismiss: onClose, componentToBeUnlinkedName: componentToBeUnlinked?.name, onProceed: onProceed }));
}
exports.default = react_1.default.memo(RemoveSystemComponentAssociationDialog);
